// src/components/pos/CreditPaymentModal.js
import React, { useState } from 'react';
import {
    Modal, Box, Typography, Button, TextField,
    Autocomplete, Alert, CircularProgress
} from '@mui/material';
import api from '../../api/index.js';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 500 },
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const CreditPaymentModal = ({ open, onClose, customers, cashSessionId, onPaymentSuccess }) => {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [amount, setAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

console.log("CreditPaymentModal recibió cashSessionId:", cashSessionId);

    const handleSave = async () => {
        if (!selectedCustomer || !amount || parseFloat(amount) <= 0) {
            setError('Debes seleccionar un cliente e introducir un monto válido.');
            return;
        }
        setLoading(true);
        setError('');
        try {
            const payload = {
                amount: parseFloat(amount),
                cash_session_id: cashSessionId
            };

            console.log("Enviando payload de abono:", payload);
            await api.post(`/customers/${selectedCustomer.id}/payments`, payload);
            alert('Abono registrado exitosamente.');
            onPaymentSuccess(); // Notificar al padre para que recargue datos
            onClose(); // Cerrar el modal
        } catch (err) {
            setError(err.response?.data?.message || 'Error al registrar el abono.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>
                <Typography variant="h6" component="h2">Registrar Abono a Crédito</Typography>
                {error && <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>}
                
                <Autocomplete
                    options={customers}
                    getOptionLabel={(option) => option.name || ''}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    value={selectedCustomer}
                    onChange={(event, newValue) => setSelectedCustomer(newValue)}
                    renderInput={(params) => <TextField {...params} margin="normal" label="Buscar Cliente" />}
                />
                
                {selectedCustomer && (
                    <Typography variant="body1" sx={{ mt: 2 }}>
                        Saldo Deudor Actual: <strong>{`$${Number(selectedCustomer.credit_balance || 0).toFixed(2)}`}</strong>
                    </Typography>
                )}

                <TextField
                    margin="normal" required fullWidth autoFocus
                    label="Monto del Abono" name="amount" type="number"
                    value={amount} onChange={(e) => setAmount(e.target.value)}
                />
                
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button onClick={onClose} sx={{ mr: 1 }} disabled={loading}>Cancelar</Button>
                    <Button variant="contained" onClick={handleSave} disabled={loading}>
                        {loading ? <CircularProgress size={24} /> : 'Registrar Abono'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default CreditPaymentModal;